/* eslint tailwindcss/no-custom-classname: off */
import { Space } from '@/components/layout'
import { Container, Breadcrumb } from './'

export const Header: React.FC = () => {
  return (
    <header>
      <div id="global" className="flexbox back-white">
        <Space />
        <Container />
        <Space />
      </div>
      <Breadcrumb />
    </header>
  )
}
